import ReferralClaimEntity from '../entities/ReferralClaim.Entity';
import { apiPut } from '../support/helpers/ApiConnection.Helper';

export function sendReferralClaim(referralClaimId: number, referralClaim: ReferralClaimEntity, abortSignal: AbortSignal): Promise<ReferralClaimEntity> {
    return apiPut<ReferralClaimEntity>('/referral-claims', referralClaimId, referralClaim, abortSignal);
}
